import { useState } from "react";
import siteConfig from "../lib/siteConfig";

const weekdayOrder = ["ma", "ti", "ke", "to", "pe", "la", "su"];
const weekdayNames = {
  ma: "maanantai",
  ti: "tiistai",
  ke: "keskiviikko",
  to: "torstai",
  pe: "perjantai",
  la: "lauantai",
  su: "sunnuntai",
};

export default function OpeningToday({ openingHours }) {
  const [isOpen, setIsOpen] = useState(false);

  const today = new Date();
  const todayKey = ["su", "ma", "ti", "ke", "to", "pe", "la"][today.getDay()];
  const todayHours = openingHours?.[todayKey] || "-";

  return (
    <div>
      <div className="flex items-center gap-2">
        <div>{siteConfig.content.openToday}</div>
        <div className="ml-auto sm:ml-0">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="inline-flex items-center btn-secondary"
            aria-expanded={isOpen}
          >
            <span>{todayHours}</span>
            <svg
              className={`w-4 h-4 ml-2 transition-transform duration-300 ${
                isOpen ? "rotate-180" : "rotate-0"
              }`}
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.25a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>

      <ul
        className={`overflow-hidden transition-all duration-300 ease-in-out transform ${
          isOpen
            ? "opacity-100 translate-y-0 pointer-events-auto max-h-96"
            : "opacity-0 -translate-y-2 pointer-events-none max-h-0"
        } space-y-1`}
        aria-hidden={!isOpen}
      >
        {weekdayOrder.map((key, index) => (
          <li
            key={key}
            className={`flex justify-between ${
              key === todayKey ? "font-bold" : ""
            } ${index === 0 ? "mt-2" : ""}`}
          >
            <span>{weekdayNames[key]}</span>
            <span>{openingHours?.[key] || "-"}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
